import { render, staticRenderFns } from "./DrqButtons.vue?vue&type=template&id=1c5dd1fa&"
import script from "./DrqButtons.vue?vue&type=script&lang=js&"
export * from "./DrqButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports